import React from 'react';

const RADIUS = 14;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

const ProgressDonut = ({ percent, color, size = 34 }) => {
  const offset = CIRCUMFERENCE - (percent / 100) * CIRCUMFERENCE;
  return (
    <div style={{ position: 'relative', width: size, height: size }}>
      <svg width={size} height={size}>
        <circle cx={size / 2} cy={size / 2} r={RADIUS} stroke="#eef0f4" strokeWidth="3.5" fill="none" />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={RADIUS}
          stroke={color}
          strokeWidth="3.5"
          fill="none"
          strokeDasharray={CIRCUMFERENCE}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
      <div style={{ position: 'absolute', top: 0, left: 0, width: size, height: size, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 9, fontWeight: 700 }}>
        {percent}%
      </div>
    </div>
  );
};

export default ProgressDonut;
